import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {ConstructsDetailsComponent} from './constructs-details.component';

const routes: Routes = [
  {path: 'constructs/details', component: ConstructsDetailsComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})

export class ConstructsDetailsRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/constructs/constructs-details/constructs-details-routing.module.ts